/*
 ### WARNING: This file is generated from template, edit the file under build-resources/template ###
 */

const Config = {
    environment: "prod",
    version: "1.7.6",

};

export default Config;



// WEBPACK FOOTER //
// ./src/constants/app/config.js